import React from "react";

export class PagePlaceholder extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"tool__content__page__wrapper"}>
                <h1>{this.props.page.title}</h1>
                <p>Nog verder door ontwikkelen: {this.props.page.kind}</p>

            </div>

        );
    }

}